import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { getGetDocumentRequestQueryOptions } from '@area-restrita/api-client/endpoints/document-request/document-request.gen';

import TenantDocumentRequestDetails from '@/modules/document-requests/pages/tenant-document-request-details';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/document-requests/$documentRequestId',
)({
  head: () => ({
    meta: [{ title: 'Detalhes da Solicitação de Documento' }],
  }),
  parseParams: z.object({
    documentRequestId: z.coerce.number(),
  }).parse,
  loader: async ({
    params: { documentRequestId },
    context: { queryClient },
  }) => {
    const documentRequest = await queryClient.ensureQueryData(
      getGetDocumentRequestQueryOptions(documentRequestId),
    );

    return documentRequest;
  },
  component: function TenantDocumentRequestDetailsRoute() {
    const documentRequest = Route.useLoaderData();

    return <TenantDocumentRequestDetails documentRequest={documentRequest} />;
  },
});
